import { FC, useEffect, useState } from 'react'
import cn from 'classnames'
import IconSearch from 'remixicon/icons/System/search-line.svg?react'
import { NumberInput } from 'shared/components'

export interface OrderFilterSearchInputProps {
  onSetSearch: (search: string) => void
  search: string | null | undefined
  className?: string
  inputClassName?: string
  placeholder?: string
  size?: 'sm' | 'nm' | 'lg'
}

export const OrderFilterSearchInput: FC<OrderFilterSearchInputProps> = ({
  search,
  onSetSearch,
  size = 'nm',
  className = '',
  inputClassName = '',
  placeholder = '№ заявки или трек-номер'
}) => {
  const [localSearchValue, setLocalSearchValue] = useState(search || '')

  useEffect(() => {
    setLocalSearchValue(search || '')
  }, [search])

  const handleChange = (value: string) => {
    setLocalSearchValue(value)
    onSetSearch(value)
  }

  const showValidationMessage = localSearchValue && localSearchValue.length > 0 && localSearchValue.length < 3

  return (
    <div className={className}>
      <NumberInput
        isClearable
        className={cn(inputClassName, '!rounded-md')}
        max={9999999999999}
        onChange={handleChange}
        placeholder={placeholder}
        prefix={<IconSearch className="text-on-surface-variant" containerSize="nm" size="xs" />}
        size={size}
        thousandsSeparator=""
        value={localSearchValue}
      />
      {showValidationMessage && (
        <div className="mt-1 text-body-sm text-attention">Для поиска необходимо ввести не менее 3 символов</div>
      )}
    </div>
  )
}
